exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-container {\n  height: auto !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/poi-dtl-del/poi-dtl-del.component.scss
// module id = ../../../../../src/app/poi-dtl-del/poi-dtl-del.component.scss
// module chunks = main